<script setup lang="ts">
import { storeToRefs } from "pinia";
import PageHeader from "./components/menu/PageHeader.vue";
import { useAuthStore } from "./stores/auth";
import ToastHandler from "./components/shared/ToastHandler.vue";
import NavigationDraw from "./components/menu/NavigationDraw.vue";
import { watch } from "vue";
import { useTerminalsStore } from "./stores/terminals";
import { useRoute } from "vue-router";
import VoyageNavigationDraw from "./components/menu/VoyageNavigationDraw.vue";

const authStore = useAuthStore();
const terminalsStore = useTerminalsStore();
const route = useRoute();

const { terminalsList } = storeToRefs(terminalsStore);
const { isAuthenticated } = storeToRefs(authStore);

/**
 * Uses the route to identify the current terminal, if one has been selected
 */
function setActiveTerminalFromRoute() {
  const terminalToSet = terminalsList.value.find(
    (t) => t.id == Number(route.params.terminalId),
  );
  if (route.params.terminalId && terminalToSet) {
    terminalsStore.setActiveTerminal(terminalToSet);
  }
}

// When the user is authenticated, fetch the terminals and set the route
watch(
  isAuthenticated,
  async () => {
    await terminalsStore.getTerminals();
    setActiveTerminalFromRoute();
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <v-app v-if="isAuthenticated">
    <PageHeader />
    <suspense>
      <div>
        <NavigationDraw />
        <VoyageNavigationDraw />
        <v-main>
          <router-view :key="$route.fullPath" class="sub-menu-offset" />
          <ToastHandler />
        </v-main>
      </div>
    </suspense>
  </v-app>
</template>

<script lang="ts"></script>
